import { Injectable } from '@angular/core';
import { EvaluationAthleteQuestionProvider } from './evaluation-athlete-question-provider.services';
import { EvaluationAthleteQuestionCategoryProvider } from './evaluation-athlete-question-category-provider.services';
import { EvaluationAthleteRights } from './evaluation-athlete-rights';
import { CurrentUserRolesProvider } from '../../organizations/providers/current-user-roles-provider';
import { OrganizationsProvider } from '../../organizations/providers/organizations-provider';
import { Observable } from 'rxjs';
import { CurrentUser } from "../../common/providers/current-user";
import { ApiBaseService } from "../../common/providers/api-base-service";
import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { CoachesProvider } from "../../coaches/providers/coaches-provider";
import { GuestsProvider } from "../../guests/providers/guests-provider";
import { EvaluationAthlete, EvaluationAthleteData } from "../../common/models/evaluation-athlete";
import { Evaluation } from '../../common/models/evaluation';
import { Answer } from "../../common/models/answer";
import { Athlete } from "../../common/models/athlete";
import { Organization } from "../../common/models/organization";
import { map } from "rxjs/operators";
import { Paginator } from "../../common/models/paginator";

@Injectable({providedIn: 'root'})
export class EvaluationAthleteProvider {

    private evaluationAthletesRights: EvaluationAthleteRights = new EvaluationAthleteRights(this.utils);

    constructor(
        private evaluationAthleteQuestionProvider: EvaluationAthleteQuestionProvider,
        private evaluationAthleteQuestionCategoryProvider: EvaluationAthleteQuestionCategoryProvider,
        private currentUser: CurrentUser,
        private api: ApiBaseService,
        private utils: UtilsProvider,
        private currentUserRoles: CurrentUserRolesProvider,
        private coachesProvider: CoachesProvider,
        private organizationProvider: OrganizationsProvider,
        private guestsProviders: GuestsProvider,
    ) {}

    /**
     * Find one EvaluationAthlete by id and join Evaluation and Answers
     // * @deprecated
     */
    // public find(evaluationAthleteId: number, organizationCode: string): Promise<EvaluationAthlete> {
    //     return new Promise<EvaluationAthlete>((resolve, reject) => {
    //         const loadEvaluationAthlete = new Promise<EvaluationAthlete>((resolve2) => {
    //             // this.storage.select(EvaluationAthlete)
    //             //     .where('id').equals(evaluationAthleteId)
    //             //     .get(1)
    //             //     .then((evaluationsAthlete: EvaluationAthlete) => {
    //             //         resolve2(evaluationsAthlete);
    //             //     })
    //             // ;
    //         });
    //
    //         const loadEvaluation = new Promise<Evaluation>((resolveEvaluation) => {
    //           // this.storage.select(Evaluation)
    //           // .where('id').equals(EvaluationAthlete, 'evaluationId')
    //           // .and('id', EvaluationAthlete).equals(evaluationAthleteId)
    //           // .get(1)
    //           // .then((evaluation: Evaluation) => {
    //           //   resolveEvaluation(evaluation);
    //           // });
    //          });
    //
    //         const loadAnswersCoach = new Promise<Answer[]>((resolveAnswerCoach) => {
    //             const loadAnswers = new Promise<Answer[]>((resolveAnswer) => {
    //               // this.storage.select(Answer)
    //               //   .where('evaluationAthleteId').equals(evaluationAthleteId)
    //               //   .and('coachId').notEquals(null)
    //               //   .and('athleteId').equals(null)
    //               //   .get()
    //               //   .then((answers: Answer[]) => {
    //               //       resolveAnswer(answers);
    //               //   })
    //               }
    //             );
    //
    //             Promise.all([
    //                 loadAnswers,
    //                 this.evaluationAthleteQuestionProvider.findByEvaluationAthleteId(evaluationAthleteId),
    //                 this.evaluationAthleteQuestionCategoryProvider.findAlll(),
    //             ]).then((data) => {
    //                 data[1].map((question) => {
    //                     // question['category'] = data[2].filter((c) => c.id === question.questionCategoryId).shift();
    //                 });
    //
    //                 data[0].map((answer: any) => {
    //                     answer['question'] = data[1].filter((q) => q.id === answer.questionId).shift();
    //                 });
    //
    //                 resolveAnswerCoach(data[0]);
    //             });
    //         });
    //
    //         const loadAnswersAthlete = new Promise<Answer[]>((resolveAnswerAthlete) => {
    //             const loadAnswers = new Promise<Answer[]>((resolveAnswer) => {
    //               // this.storage.select(Answer)
    //               //     .where('evaluationAthleteId').equals(evaluationAthleteId)
    //               //     .and('athleteId').notEquals(null)
    //               //     .and('coachId').equals(null)
    //               //     .get()
    //               //     .then((answers: Answer[]) => {
    //               //       resolveAnswer(answers);
    //               //     })
    //               }
    //             );
    //
    //             Promise.all([
    //                 loadAnswers,
    //                 this.evaluationAthleteQuestionProvider.findByEvaluationAthleteId(evaluationAthleteId),
    //                 this.evaluationAthleteQuestionCategoryProvider.findAlll(),
    //             ]).then((data) => {
    //                 // data[1].map((question) => {
    //                 //     question['category'] = data[2].filter((c) => c.id === question.questionCategoryId).shift();
    //                 // });
    //
    //                 data[0].map((answer: any) => {
    //                     answer['question'] = data[1].filter((q) => q.id === answer.questionId).shift();
    //                 });
    //
    //                 resolveAnswerAthlete(data[0]);
    //             });
    //         });
    //
    //         Promise.all([
    //             loadEvaluationAthlete,
    //             loadEvaluation,
    //             loadAnswersAthlete,
    //             loadAnswersCoach,
    //             this.coachesProvider.getAthleteCoachRelations(),
    //             // this.storage.select(OrganizationMembership).get(),
    //             // this.coachesProvider.getCoaches(),
    //             // this.storage.select(Athlete).get(),
    //             this.organizationProvider.getByCode(organizationCode),
    //             this.guestsProviders.getAthleteGuestRelations(organizationId),
    //             this.guestsProviders.getGuests(organizationId),
    //         ]).then((data:any) => {
    //
    //             this.evaluationAthletesRights.evaluateItemRight({
    //                 user: this.currentUser.user!,
    //                 organizationId: data[8].id,
    //                 evaluationAthlete: data[0],
    //                 rolesIds: this.currentUserRoles.getRolesIds(data[8].id),
    //                 athleteCoachRelations: data[4],
    //                 athleteMemberships: data[5],
    //                 coaches: data[6],
    //                 athletes: data[7],
    //                 athleteGuestRelations: data[9],
    //                 guests: data[10],
    //             });
    //
    //             resolve(Object.assign(data[0], {
    //                 evaluation: data[1],
    //                 answersAthlete: data[2],
    //                 answersCoach: data[3],
    //                 rights: this.evaluationAthletesRights.getItemRightsList(),
    //             }));
    //         });
    //     });
    // }

    /**
     // * Returns an array with Evaluation and the latest AthleteEvaluation belonging
     // * to this evaluation.
     // * @example
     // * [{evaluation: ..., evaluationAthlete: ...}, {evaluation: ..., evaluationAthlete: ...}]
     // *
     // * @param athlete
     // * @param organization
     // * @deprecated
     // */
    // public async findLatestGroupedCategoryByAthleteAndOrganization(athlete: Athlete, organization: Organization) {
    //     return new Promise<any[]>((resolve, reject) => {
    //         const evaluation = new Promise<Evaluation[]>((resolveEvaluation) => {
    //             // this.storage.select(Evaluation)
    //             //     .get()
    //             //     .then((evaluations: Evaluation[]) => {
    //             //         resolveEvaluation(evaluations);
    //             //     })
    //             // ;
    //         });
    //
    //         Promise.all([evaluation]).then((data : any) => {
    //             const getEvaluationAthlete = (ev: any) => new Promise((res, rej) => {
    //                 // this.storage.select(EvaluationAthlete)
    //                 //     .where('evaluationId').equals(ev.id)
    //                 //     .and('athleteId').equals(athlete.id)
    //                 //     .and('organizationId').equals(organization.id)
    //                 //     .orderBy('date', 'desc')
    //                 //     .get(1)
    //                 //     .then((ea: EvaluationAthlete) => res(ea))
    //                 // ;
    //             });
    //
    //             const toReturn:any[] = [];
    //             (async function() {
    //                 for (const key of Object.keys(data[0])) {
    //                     const ev = data[0][key];
    //
    //                     toReturn.push({
    //                         evaluation: ev,
    //                         evaluationAthlete: await getEvaluationAthlete(ev),
    //                     });
    //                 }
    //             })();
    //
    //             resolve(toReturn);
    //         });
    //     });
    // }

    /**
     * @deprecated
     */
    public findLatestByAthleteAndOrganization(athlete: Athlete, organization: Organization, limit = 1): Promise<EvaluationAthlete[]> {
        return new Promise<EvaluationAthlete[]>((resolve, reject) => {

            const evaluationAthlete = new Promise<EvaluationAthlete[]>((resolve2) => {
                // this.storage.select(EvaluationAthlete)
                //     .where('athleteId').equals(athlete.id)
                //     .and('organizationId').equals(organization.id)
                //     .orderBy('date', 'desc')
                //     .get(limit)
                //     .then((evaluationsAthletes: EvaluationAthlete[]) => {
                //         if (!Array.isArray(evaluationsAthletes)) {
                //             evaluationsAthletes = [evaluationsAthletes];
                //         }
                //
                //         resolve2(evaluationsAthletes);
                //     })
                // ;
            });

            const evaluation = new Promise<Evaluation[]>((resolveEvaluation) => {
                // this.storage.select(Evaluation)
                //     .get()
                //     .then((evaluations: Evaluation[]) => {
                //         resolveEvaluation(evaluations);
                //     })
                // ;
            });

            Promise.all([evaluationAthlete, evaluation]).then((data: any) => {
                for (const key of Object.keys(data[0])) {
                    const ea = data[0][key];
                    const evaluations = data[1];

                    ea['evaluation'] = evaluations.filter((ev: any) => ev.id === ea.evaluationId).shift();
                }

                resolve(data[0]);
            });
        });
    }

    /**
     * Find all EvaluationAthlete for an athlete and join Evaluation on result
     *
     // * @param athlete
     // * @param organization
     */
    // public findAllByAthleteAndOrganization(athlete: Athlete, organization: Organization): Promise<EvaluationAthlete[]> {
    //     return new Promise<EvaluationAthlete[]>((resolve, reject) => {
    //
    //         const evaluationAthlete = new Promise<EvaluationAthlete[]>((resolve2) => {
    //             // this.storage.select(EvaluationAthlete)
    //             //     .where('athleteId').equals(athlete.id)
    //             //     .and('organizationId').equals(organization.id)
    //             //     .orderBy('date', 'desc')
    //             //     .get()
    //             //     .then((evaluationsAthletes: EvaluationAthlete[]) => {
    //             //         resolve2(evaluationsAthletes);
    //             //     })
    //             // ;
    //         });
    //
    //         const evaluation = new Promise<Evaluation[]>((resolveEvaluation) => {
    //             // this.storage.select(Evaluation)
    //             //     .get()
    //             //     .then((evaluations: Evaluation[]) => {
    //             //         resolveEvaluation(evaluations);
    //             //     })
    //             // ;
    //         });
    //
    //         Promise.all([
    //
    //             evaluationAthlete,
    //             evaluation,
    //             this.coachesProvider.getAthleteCoachRelations(),
    //             // this.storage.select(OrganizationMembership).get(),
    //             // this.coachesProvider.getCoaches(),
    //             // this.storage.select(Athlete).get(),
    //             this.guestsProviders.getAthleteGuestRelations(),
    //             this.guestsProviders.getGuests(),
    //
    //         ])
    //             .then((data: any[]) => {
    //
    //                 for (const key of Object.keys(data[0])) {
    //                     const ea = data[0][key];
    //                     const evaluations = data[1];
    //
    //                     ea['evaluation'] = evaluations.filter((ev: any) => ev.id === ea.evaluationId).shift();
    //
    //                     this.evaluationAthletesRights.evaluateItemRight({
    //                         user: this.currentUser.user!,
    //                         organizationId: organization.id!,
    //                         evaluationAthlete: ea,
    //                         rolesIds: this.currentUserRoles.getRolesIds(organization.id!),
    //                         athleteCoachRelations: data[2],
    //                         athleteMemberships: data[3],
    //                         coaches: data[4],
    //                         athletes: data[5],
    //                         athleteGuestRelations: data[6],
    //                         guests: data[7],
    //                     });
    //                     ea['rights'] = this.evaluationAthletesRights.getItemRightsList();
    //                 }
    //
    //                 resolve(data[0]);
    //             })
    //             .catch(reject);
    //     });
    // }



  /***
   @param organizationId
   @param athleteId
   @param evaluationId
   @returns {Observable<any>}
   */
    public getAthleteEvaluation(organizationId: number, athleteId: number, evaluationId: number): Observable<any> {
      return this.api.call('get', 'organizations/' + organizationId + '/athletes/' + athleteId + '/evaluations/' + evaluationId, {}, this.currentUser.getAccessToken()).pipe(
        map((response: EvaluationAthleteData) => {
            return EvaluationAthlete.fromAPI(response);
        })
      );
   }

  /***
   @param organization
   @param athlete
   @param evaluationId
   @returns {Observable<any>}
   */
    public get(organization: Organization, athlete: Athlete, evaluationId: number): Observable<EvaluationAthlete> {
      return this.api.call('get',`organizations/${organization.code}/athletes/${athlete.userId}/evaluations/${evaluationId}`, {}, this.currentUser.getAccessToken()).pipe(
        map((response: EvaluationAthlete) => {
            return EvaluationAthlete.fromAPI(response);
        })
      );
    }

    public getPreview(organization: Organization, athlete: Athlete): Observable<any> {
        return this.api.call('get', `organizations/${organization.code}/athletes/${athlete.userId}/evaluations/preview`, {}, this.currentUser.getAccessToken());
    }

    public getAll(organization: Organization, athlete: Athlete): Observable<EvaluationAthlete[]> {
        return this.api.call('get', `organizations/${organization.code}/athletes/${athlete.userId}/evaluations/`, {}, this.currentUser.getAccessToken()).pipe(
            map((response: EvaluationAthlete[]) => {
                return response.map((evaluationAthlete) => EvaluationAthlete.fromAPI(evaluationAthlete));
            })
        );
    }

    public getByAthletePaginated(organization: Organization, athlete: Athlete, page = 0, limit = 0): Observable<Paginator> {
        return this.api.call('get', `organizations/${organization.code}/athletes/${athlete.userId}/evaluations/?page=${page}&limit=${limit}`, {}, this.currentUser.getAccessToken());
        // return this.apiService.get('organizations/' + organization.id + '/athletes/' + athlete.userId + '/evaluations/?page=' + page + '&limit=' + limit);
    }

    public save(organization: any, evaluation:any): Observable<EvaluationAthlete> {
        const url = `organizations/${organization.code}/evaluations/new`;

        return this.api.call('post', url, evaluation, this.currentUser.getAccessToken(), true);
    }

    public update(organization: any, evaluation: any): Observable<EvaluationAthlete> {
        const url = `organizations/${organization.code}/evaluations/update`;
        return this.api.call('post', url, evaluation, this.currentUser.getAccessToken(), true)
    }

    public closeEvaluation(organization: any, evaluation: any): Observable<EvaluationAthlete> {
        return this.api.call('post', `organizations/${organization.code}/evaluations/close`, evaluation, this.currentUser.getAccessToken(), true);
    }

    public delete(organizationId: number, evaluation: EvaluationAthlete): Observable<any> {
        return this.api.call(                'delete',
            'organizations/' + organizationId + '/evaluations/' + evaluation.id,
            {},
            this.currentUser.getAccessToken()
        )
    }
}
